import { atom, selector } from 'recoil'
import { AccountId, IAccount } from '../types/types'
import { loggedUserState } from './logged-user-state'
import { userAccountsState } from './user-accounts'
import { accountState } from './account-state'

export const selectedAccountState = atom<IAccount | null>({
  key: 'selectedAccountState',
  default: selector({
    key: 'selectedAccountState/Default',
    get: ({ get }) => {
      const user = get(loggedUserState)
      const id = user?.id

      console.log('HERE', id)

      if (!id) {
        return null
      }

      console.log('HERE')

      const accounts = get(userAccountsState(id))
      const accountId = accounts[0]?.id

      const accountInfo = get(accountState(accountId))
      console.log(accounts)

      return accountInfo || null
    },
  }),
})